import PropTypes from "prop-types";
import StepProgreassBar from "./StepProgressBar";
import { useContext } from "react";
import { AppContext } from "../util/AppContext";
import { getConfigValue } from "../util/getConfigValue";
import { focusTypeName } from "../util/constants";

ProfessionalPrintingStepProgressBar.propTypes = {
    currentStepId: PropTypes.string,
    focusType: PropTypes.string
}
ProfessionalPrintingStepProgressBar.defaultProps = {
	focusType: focusTypeName.HCPs,
};

export const ProfessionaPrintingStepIds = Object.freeze({
    CREATEDOCUMENT: "createDocument",
    PLACEORDER: "placeORder",
    COMPLETED: "completed"
});

function ProfessionalPrintingStepProgressBar({ currentStepId, focusType }) {
    const [appState] = useContext(AppContext);

    const stepsOrder = [
        ProfessionaPrintingStepIds.CREATEDOCUMENT,
        ProfessionaPrintingStepIds.PLACEORDER,
        ProfessionaPrintingStepIds.COMPLETED
    ];

    const steps =[
        {
            id: ProfessionaPrintingStepIds.CREATEDOCUMENT,
            label: getConfigValue(appState.config?.ProfessionalPrinting?.BreadCrumb?.CreateDocument?.Label, appState)?.Value || null,
            current: isCurrent(ProfessionaPrintingStepIds.CREATEDOCUMENT),
            completed: isCompleted(ProfessionaPrintingStepIds.CREATEDOCUMENT),
            path: isCompleted(ProfessionaPrintingStepIds.CREATEDOCUMENT) ? "/createProfessionalPrintingDocument" : ""
        },
        {
            id: ProfessionaPrintingStepIds.PLACEORDER,
            label: getConfigValue(appState.config?.ProfessionalPrinting?.BreadCrumb?.PlaceOrder?.Label, appState)?.Value || null,
            current: isCurrent(ProfessionaPrintingStepIds.PLACEORDER),
            completed: isCompleted(ProfessionaPrintingStepIds.PLACEORDER),
            path: ""
        }
    ];

    function isCompleted(stepId){
        const currentIndex = stepsOrder.indexOf(currentStepId);
        const stepIndex = stepsOrder.indexOf(stepId);

        return stepIndex < currentIndex;
    }

    function isCurrent(stepId){
        const currentIndex = stepsOrder.indexOf(currentStepId);
        const stepIndex = stepsOrder.indexOf(stepId);

        return stepIndex === currentIndex;
    }

    const orderdSteps = steps.toSorted((a,b) => 
        stepsOrder.indexOf(a.id) - stepsOrder.indexOf(b.id)
    );

    return (
        <StepProgreassBar
            title={getConfigValue(appState.config?.ProfessionalPrinting?.Header, appState)?.Value || null}
            steps={orderdSteps}
        />
    );
}

export default ProfessionalPrintingStepProgressBar;